import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import type { ModuleState } from '@redux/modules/module'

import PaginationRuleEditRoutes from './routes'

const PaginationRuleEdit = () => {
  const { paginationRuleId } = useNumericParams()

  useReduxAction(
    'paginationRules',
    'loadPaginationRule',
    {
      entityId: paginationRuleId,
      include_pagination_rule_brand: true,
      include_brand_logo: true,
    },
    [paginationRuleId],
    {
      dispatchAction: (action: Function, requestOptions) => action(paginationRuleId, requestOptions),
      shouldPerformFn: ({ loading }: ModuleState) => !!paginationRuleId && !loading,
    },
  )

  return (
    <PaginationRuleEditRoutes />
  )
}

export default PaginationRuleEdit
